import React, { FC, useCallback, useState } from 'react';
import IndicatorsModeContext from './IndicatorsModeContext';
import { BookmarkModeEnum, NotesModeEnum } from '../constants';
import { BookmarkMode, NotesMode } from '../types';
import { logWarning } from '../helpers';

const IndicatorsModeProvider: FC = ({ children }) => {
  const [bkmode, setBkmode] = useState<BookmarkMode>({
    mode: BookmarkModeEnum.DISABLED,
  });
  const [ntmode, setNtmode] = useState<NotesMode>({
    mode: NotesModeEnum.DISABLED,
  });

  const setBookmarkMode = useCallback(
    (newMode: BookmarkMode) => {
      if (newMode.mode === BookmarkModeEnum.TEACHER_OPTIONS && newMode.blockId == null) {
        logWarning(
          'BookmarkMode set to TEACHER_OPTIONS but no blockId was provided. BookmarkMode was reset to DISABLED.'
        );
        setBkmode({ mode: BookmarkModeEnum.DISABLED });
      } else {
        setBkmode(newMode);
      }
    },
    [setBkmode]
  );

  return (
    <IndicatorsModeContext.Provider
      value={{ bookmarkMode: bkmode, setBookmarkMode, notesMode: ntmode, setNotesMode: setNtmode }}
    >
      {children}
    </IndicatorsModeContext.Provider>
  );
};

export default IndicatorsModeProvider;
